(function () {
  function ntShopCurrency() {
    return String(window.Shopify && Shopify.currency && Shopify.currency.active || 'USD').toUpperCase();
  }

  window.NTRedesignCurrency = {
    format: function (cents) {
      var currency = ntShopCurrency();
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: currency === 'JPY' ? 0 : 2
      }).format(Number(cents || 0) / 100);
    },
    current: ntShopCurrency
  };

  function initHeader() {
    var header = document.querySelector('[data-nt-header]');
    if (!header || header.dataset.ready) return;
    header.dataset.ready = 'true';
    var toggle = header.querySelector('.nt-menu-toggle');
    var menu = header.querySelector('.nt-mobile-nav');
    var search = header.querySelector('[data-nt-header-search]');
    var searchToggle = search && search.querySelector('.nt-search-toggle');
    var searchForm = search && search.querySelector('.nt-search-form');
    var searchInput = searchForm && searchForm.querySelector('input[type="search"]');
    var searchClose = searchForm && searchForm.querySelector('.nt-search-close');
    var searchSuggestions = searchForm && searchForm.querySelector('[data-nt-search-suggestions]');
    var searchTimer;
    var searchRequest = 0;
    var market = header.querySelector('[data-nt-market-selector]');
    var marketToggle = market && market.querySelector('.nt-market-toggle');
    var marketMenu = market && market.querySelector('.nt-market-menu');
    var cartWrap = header.querySelector('.nt-cart-wrap');
    var currencyEngineObserver;
    var observedCurrencyEngine;

    if (cartWrap) {
      cartWrap.addEventListener('mouseenter', function () { cartWrap.classList.add('is-open'); });
      cartWrap.addEventListener('mouseleave', function () { cartWrap.classList.remove('is-open'); });
      cartWrap.addEventListener('focusin', function () { cartWrap.classList.add('is-open'); });
      cartWrap.addEventListener('focusout', function (event) {
        if (!cartWrap.contains(event.relatedTarget)) cartWrap.classList.remove('is-open');
      });
    }

    function countryFlag(countryCode) {
      if (!countryCode || countryCode.length !== 2) return '◉';
      return countryCode.toUpperCase().replace(/./g, function (character) {
        return String.fromCodePoint(127397 + character.charCodeAt(0));
      });
    }

    function currencyCountry(code) {
      return ({
        USD: 'US', EUR: 'EU', GBP: 'GB', CAD: 'CA', JPY: 'JP', AUD: 'AU',
        CNY: 'CN', NZD: 'NZ', CHF: 'CH', HKD: 'HK', SGD: 'SG', INR: 'IN',
        KRW: 'KR', MXN: 'MX', BRL: 'BR', SEK: 'SE', NOK: 'NO', DKK: 'DK'
      })[code] || 'US';
    }

    function normalizedCurrencyCode(value) {
      var match = String(value || '').toUpperCase().match(/\b[A-Z]{3}\b/);
      return match ? match[0] : '';
    }

    function currencyEngineRoot() {
      return document.querySelector('#cb-widget-currency');
    }

    function currencyEngineCode(root) {
      root = root || currencyEngineRoot();
      if (!root) return '';
      var launcher = root.querySelector('#launch-btn-widget');
      return normalizedCurrencyCode(launcher && launcher.textContent);
    }

    function currencyEngineCodes(root) {
      root = root || currencyEngineRoot();
      if (!root) return [];
      return Array.prototype.slice.call(root.querySelectorAll('.cb-currency-item')).map(function (item) {
        return normalizedCurrencyCode(item.textContent);
      }).filter(function (code, index, codes) {
        return code && code !== 'PKR' && codes.indexOf(code) === index;
      });
    }

    function currentAppCurrency() {
      return currencyEngineCode() || ntShopCurrency();
    }

    function renderCurrencyAppOptions(codes, currentCode) {
      if (!market || !market.hasAttribute('data-nt-currency-app') || !codes.length) return;
      var options = market.querySelector('.nt-market-options');
      if (!options) return;
      var normalizedCodes = codes.slice();
      if (currentCode && normalizedCodes.indexOf(currentCode) < 0) normalizedCodes.unshift(currentCode);
      var signature = normalizedCodes.join('|');
      if (options.dataset.currencySignature === signature) return;
      options.dataset.currencySignature = signature;
      options.innerHTML = '';
      normalizedCodes.forEach(function (code) {
        var option = document.createElement('button');
        option.className = 'nt-market-option';
        option.type = 'button';
        option.dataset.currencyAppCode = code;
        var symbol = document.createElement('span');
        symbol.className = 'nt-market-currency-symbol';
        symbol.setAttribute('aria-hidden', 'true');
        symbol.textContent = code.slice(0, 1);
        var name = document.createElement('span');
        name.textContent = code;
        var suffix = document.createElement('b');
        suffix.textContent = code;
        option.appendChild(symbol);
        option.appendChild(name);
        option.appendChild(suffix);
        options.appendChild(option);
      });
    }

    function updateCurrencyAppLabel(code) {
      if (!market || !market.hasAttribute('data-nt-currency-app')) return;
      code = String(code || currentAppCurrency()).toUpperCase();
      var label = market.querySelector('[data-nt-current-currency]');
      var flag = market.querySelector('[data-nt-current-currency-flag]');
      if (label) label.textContent = code;
      if (flag) {
        flag.dataset.countryFlag = currencyCountry(code);
        flag.textContent = countryFlag(flag.dataset.countryFlag);
      }
      market.querySelectorAll('[data-currency-app-code]').forEach(function (option) {
        option.classList.toggle('is-current', option.dataset.currencyAppCode === code);
        if (option.dataset.currencyAppCode === code) option.setAttribute('aria-current', 'true');
        else option.removeAttribute('aria-current');
      });
    }

    function syncCurrencyAppFromEngine() {
      var root = currencyEngineRoot();
      if (!root) return false;
      var code = currencyEngineCode(root) || ntShopCurrency();
      renderCurrencyAppOptions(currencyEngineCodes(root), code);
      updateCurrencyAppLabel(code);
      return true;
    }

    function observeCurrencyEngine() {
      var root = currencyEngineRoot();
      if (!root) return false;
      syncCurrencyAppFromEngine();
      if (observedCurrencyEngine === root) return true;
      if (currencyEngineObserver) currencyEngineObserver.disconnect();
      observedCurrencyEngine = root;
      currencyEngineObserver = new MutationObserver(function () {
        window.requestAnimationFrame(syncCurrencyAppFromEngine);
      });
      currencyEngineObserver.observe(root, { childList: true, subtree: true, characterData: true });
      return true;
    }

    function prepareCurrencyAppMenu() {
      var root = currencyEngineRoot();
      if (!root) return;
      var launcher = root.querySelector('#launch-btn-widget');
      if (!root.querySelector('.cb-currency-item') && launcher) {
        launcher.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      }
      window.setTimeout(syncCurrencyAppFromEngine, 80);
      window.setTimeout(syncCurrencyAppFromEngine, 240);
    }

    function selectCurrencyApp(code) {
      var attempts = 0;
      var timer = window.setInterval(function () {
        attempts += 1;
        var root = currencyEngineRoot();
        var item = root && Array.prototype.slice.call(root.querySelectorAll('.cb-currency-item')).find(function (candidate) {
          return normalizedCurrencyCode(candidate.textContent) === code;
        });
        if (item) {
          window.clearInterval(timer);
          item.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          var confirmations = 0;
          var confirmationTimer = window.setInterval(function () {
            confirmations += 1;
            syncCurrencyAppFromEngine();
            if (currencyEngineCode() === code || confirmations >= 30) window.clearInterval(confirmationTimer);
          }, 100);
          return;
        }
        if (root && (attempts === 1 || attempts === 10)) {
          var trigger = root.querySelector('#launch-btn-widget') || root.querySelector('button, [role="button"]') || root.firstElementChild;
          if (trigger) trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        }
        if (attempts >= 40) {
          window.clearInterval(timer);
          syncCurrencyAppFromEngine();
        }
      }, 100);
    }

    header.querySelectorAll('[data-country-flag]').forEach(function (flag) {
      flag.textContent = countryFlag(flag.dataset.countryFlag);
    });
    updateCurrencyAppLabel(currentAppCurrency());
    [100, 250, 500, 1000, 2000, 4000, 7000, 12000].forEach(function (delay) {
      window.setTimeout(observeCurrencyEngine, delay);
    });

    function closeSearch() {
      if (!searchToggle || !searchForm || searchForm.hidden) return;
      searchForm.hidden = true;
      searchToggle.setAttribute('aria-expanded', 'false');
      if (searchSuggestions) searchSuggestions.hidden = true;
    }

    function renderSearchSuggestions(products, query) {
      if (!searchSuggestions) return;
      searchSuggestions.innerHTML = '';
      products.slice(0, 5).forEach(function (product) {
        var link = document.createElement('a');
        link.className = 'nt-search-result';
        link.href = product.url;

        var image = document.createElement('img');
        var imageSource = product.featured_image && (product.featured_image.url || product.featured_image);
        image.src = imageSource || product.image || '';
        image.alt = '';
        image.loading = 'lazy';

        var copy = document.createElement('span');
        var title = document.createElement('b');
        title.textContent = product.title;
        var details = document.createElement('small');
        details.textContent = product.vendor || product.type || 'NT FAIRING';
        copy.appendChild(title);
        copy.appendChild(details);

        var price = document.createElement('strong');
        var amount = Number(product.price);
        price.textContent = Number.isFinite(amount) ? '$' + amount.toFixed(2) : (product.price || '');

        link.appendChild(image);
        link.appendChild(copy);
        link.appendChild(price);
        searchSuggestions.appendChild(link);
      });

      var allResults = document.createElement('a');
      allResults.className = 'nt-search-all';
      allResults.href = '/search?type=product&q=' + encodeURIComponent(query);
      allResults.textContent = products.length ? 'VIEW ALL SEARCH RESULTS' : 'SEARCH FOR “' + query + '”';
      searchSuggestions.appendChild(allResults);
      searchSuggestions.hidden = false;
    }

    function requestSearchSuggestions(query) {
      var requestId = ++searchRequest;
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku')
        .then(function (response) { return response.ok ? response.json() : Promise.reject(new Error('Search unavailable')); })
        .then(function (payload) {
          if (requestId !== searchRequest) return;
          var products = payload.resources && payload.resources.results && payload.resources.results.products || [];
          renderSearchSuggestions(products, query);
        })
        .catch(function () {
          if (requestId === searchRequest) renderSearchSuggestions([], query);
        });
    }

    function closeMarket() {
      if (!marketToggle || !marketMenu || marketMenu.hidden) return;
      marketMenu.hidden = true;
      marketToggle.setAttribute('aria-expanded', 'false');
    }

    if (marketToggle && marketMenu) {
      marketToggle.addEventListener('click', function () {
        var open = marketToggle.getAttribute('aria-expanded') === 'true';
        if (open) {
          closeMarket();
          return;
        }
        marketMenu.hidden = false;
        marketToggle.setAttribute('aria-expanded', 'true');
        if (market.hasAttribute('data-nt-currency-app')) prepareCurrencyAppMenu();
        closeSearch();
        if (toggle && menu) {
          toggle.setAttribute('aria-expanded', 'false');
          menu.hidden = true;
        }
      });

      market.querySelectorAll('[data-country-code]').forEach(function (option) {
        option.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var form = option.closest('form');
          var input = form && form.querySelector('input[name="country_code"]');
          if (!form || !input) return;
          input.value = option.dataset.countryCode;
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else HTMLFormElement.prototype.submit.call(form);
        });
      });

      market.addEventListener('click', function (event) {
        var option = event.target.closest('[data-currency-app-code]');
        if (!option || !market.contains(option)) return;
        event.preventDefault();
        event.stopPropagation();
        var code = option.dataset.currencyAppCode;
        if (!code) return;
        closeMarket();
        selectCurrencyApp(code);
      });

      document.addEventListener('click', function (event) {
        if (!market.contains(event.target)) closeMarket();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !marketMenu.hidden) {
          closeMarket();
          marketToggle.focus();
        }
      });

    }

    if (searchToggle && searchForm) {
      searchToggle.addEventListener('click', function () {
        var open = searchToggle.getAttribute('aria-expanded') === 'true';
        if (open) {
          closeSearch();
          searchToggle.focus();
          return;
        }
        searchForm.hidden = false;
        searchToggle.setAttribute('aria-expanded', 'true');
        closeMarket();
        if (toggle && menu) {
          toggle.setAttribute('aria-expanded', 'false');
          menu.hidden = true;
        }
        window.requestAnimationFrame(function () { if (searchInput) searchInput.focus(); });
      });
      if (searchClose) {
        searchClose.addEventListener('click', function () {
          closeSearch();
          searchToggle.focus();
        });
      }
      if (searchInput && searchSuggestions) {
        searchInput.addEventListener('input', function () {
          var query = searchInput.value.trim();
          window.clearTimeout(searchTimer);
          if (query.length < 2) {
            searchRequest += 1;
            searchSuggestions.hidden = true;
            searchSuggestions.innerHTML = '';
            return;
          }
          searchTimer = window.setTimeout(function () { requestSearchSuggestions(query); }, 220);
        });
      }
      document.addEventListener('click', function (event) {
        if (!search.contains(event.target)) closeSearch();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !searchForm.hidden) {
          closeSearch();
          searchToggle.focus();
        }
      });
    }
    if (toggle && menu) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        menu.hidden = open;
        closeSearch();
        closeMarket();
      });
    }
    {
      var headerSpacer = null;
      if (!header.classList.contains('nt-site-header--overlay')) {
        headerSpacer = document.createElement('div');
        headerSpacer.setAttribute('aria-hidden', 'true');
        headerSpacer.setAttribute('data-nt-header-spacer', '');
        header.before(headerSpacer);
      }
      var updateHeader = function () {
        var scrolled = window.scrollY > 48;
        header.classList.toggle('is-scrolled', scrolled);
        if (headerSpacer) headerSpacer.style.height = scrolled ? header.offsetHeight + 'px' : '0px';
      };
      updateHeader();
      window.addEventListener('scroll', updateHeader, { passive: true });
      window.addEventListener('resize', updateHeader, { passive: true });
      if (headerSpacer && window.ResizeObserver) new ResizeObserver(updateHeader).observe(header);
    }
  }

  function hideLegacyCurrencyControl() {
    var conversionBear = document.querySelector('#cb-widget-currency');
    if (conversionBear) {
      conversionBear.setAttribute('data-nt-currency-engine', 'true');
      conversionBear.setAttribute('aria-hidden', 'true');
      conversionBear.style.setProperty('left', '-10000px', 'important');
      conversionBear.style.setProperty('right', 'auto', 'important');
      conversionBear.style.setProperty('top', '0', 'important');
      conversionBear.style.setProperty('bottom', 'auto', 'important');
      conversionBear.style.setProperty('opacity', '0', 'important');
      conversionBear.style.setProperty('pointer-events', 'none', 'important');
    }

    document.querySelectorAll('#form-currency, .currency').forEach(function (element) {
      if (element.closest('[data-nt-header]')) return;
      var wrapper = element.matches('.currency') ? element : element.closest('.currency') || element;
      wrapper.hidden = true;
      wrapper.style.display = 'none';
      wrapper.setAttribute('data-nt-hidden-legacy-currency', 'true');
    });

    var currencyCodes = /^(USD|EUR|GBP|CAD|JPY)$/;
    document.querySelectorAll('button, [role="button"]').forEach(function (element) {
      if (element.closest('[data-nt-header]') || element.hasAttribute('data-nt-hidden-legacy-currency')) return;
      var text = (element.textContent || '').replace(/\s+/g, ' ').trim();
      if (!currencyCodes.test(text)) return;
      var rect = element.getBoundingClientRect();
      if (rect.top > 150 || rect.right < window.innerWidth - 240 || rect.width > 190 || rect.height > 80) return;
      element.hidden = true;
      element.style.display = 'none';
      element.setAttribute('data-nt-hidden-legacy-currency', 'true');
    });
  }

  function initHero() {
    var hero = document.querySelector('[data-nt-hero]');
    if (!hero || hero.dataset.ready) return;
    hero.dataset.ready = 'true';
    var slides = Array.prototype.slice.call(hero.querySelectorAll('.nt-hero-slide'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-nt-hero-dot]'));
    var index = 0;
    var timer;
    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === index); });
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
    }
    function restart() {
      window.clearInterval(timer);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(function () { show(index + 1); }, 6500);
    }
    hero.querySelector('[data-nt-hero-prev]').addEventListener('click', function () { show(index - 1); restart(); });
    hero.querySelector('[data-nt-hero-next]').addEventListener('click', function () { show(index + 1); restart(); });
    dots.forEach(function (dot) { dot.addEventListener('click', function () { show(Number(dot.dataset.ntHeroDot)); restart(); }); });
    restart();
  }

  function initFinder() {
    var finder = document.querySelector('[data-nt-finder] form');
    if (!finder || finder.dataset.ready) return;
    finder.dataset.ready = 'true';
  }

  function naturalCompare(left, right) {
    return left.localeCompare(right, undefined, { numeric: true, sensitivity: 'base' });
  }

  function replaceOptions(select, placeholder, values, selectedValue) {
    select.innerHTML = '';
    var placeholderOption = document.createElement('option');
    placeholderOption.value = '';
    placeholderOption.textContent = placeholder;
    select.appendChild(placeholderOption);
    values.forEach(function (value) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      option.selected = value === selectedValue;
      select.appendChild(option);
    });
    select.disabled = values.length === 0;
  }

  function initVehicleSelectors() {
    var vehicleOptions = window.NTVehicleOptions || {};
    document.querySelectorAll('[data-nt-vehicle-form], #nt-footer-newsletter-form').forEach(function (form) {
      if (form.closest('[data-nt-carbon-vehicle]')) return;
      if (form.dataset.vehicleReady) return;
      form.dataset.vehicleReady = 'true';
      var brandSelect = form.querySelector('[data-nt-vehicle-brand]');
      var modelSelect = form.querySelector('[data-nt-vehicle-model]');
      var yearSelect = form.querySelector('[data-nt-model-year]');
      var applyButton = form.querySelector('[data-nt-apply-filter]');
      var customBrandWrap = form.querySelector('[data-nt-custom-brand-wrap]');
      var customBrandInput = form.querySelector('[data-nt-custom-brand]');
      var customModelWrap = form.querySelector('[data-nt-custom-model-wrap]');
      var customModelInput = form.querySelector('[data-nt-custom-model]');
      var customYearWrap = form.querySelector('[data-nt-custom-year-wrap]');
      var customYearInput = form.querySelector('[data-nt-custom-year]');
      var newsletterEmail = form.querySelector('[data-nt-newsletter-email]');
      var newsletterSubmit = form.querySelector('[data-nt-newsletter-submit]');
      var newsletterNote = form.querySelector('[data-nt-newsletter-note]');
      var newsletterStatus = form.querySelector('[data-nt-newsletter-status]');
      var lockedBrand = form.getAttribute('data-nt-locked-brand') || '';
      if ((!brandSelect && !lockedBrand) || !modelSelect || !yearSelect) return;
      var isNewsletterForm = form.id === 'nt-footer-newsletter-form';

      function currentBrand() {
        return brandSelect ? brandSelect.value : lockedBrand;
      }

      function resolvedBrand() {
        return currentBrand() === '__custom__' && customBrandInput ? customBrandInput.value.trim() : currentBrand();
      }

      function updateApplyState() {
        if (isNewsletterForm) {
          var isCustomBrand = currentBrand() === '__custom__';
          var isCustomModel = modelSelect.value === '__custom__';
          var isCustomYear = yearSelect.value === '__custom__';
          var hasBrand = Boolean(currentBrand() && (!isCustomBrand || customBrandInput && customBrandInput.value.trim()));
          var hasModel = Boolean(modelSelect.value && (!isCustomModel || customModelInput && customModelInput.value.trim()));
          var hasYear = Boolean(yearSelect.value && (!isCustomYear || customYearInput && customYearInput.value.trim()));
          var hasVehicle = hasBrand && hasModel && hasYear;
          var hasEmail = Boolean(newsletterEmail && newsletterEmail.validity.valid && newsletterEmail.value.trim());
          if (newsletterSubmit) {
            newsletterSubmit.disabled = !(hasVehicle && hasEmail);
            newsletterSubmit.setAttribute('aria-disabled', newsletterSubmit.disabled ? 'true' : 'false');
          }
          if (newsletterNote) {
            newsletterNote.textContent = !hasVehicle
              ? 'Select your motorcycle first.'
              : !hasEmail
                ? 'Enter your email address to subscribe.'
                : 'Ready to subscribe for updates about this motorcycle.';
          }
        }
        if (!applyButton) return;
        applyButton.disabled = lockedBrand ? !(modelSelect.value || yearSelect.value) : !(currentBrand() || modelSelect.value || yearSelect.value);
      }

      if (brandSelect) {
        Object.keys(vehicleOptions).sort(naturalCompare).forEach(function (brand) {
          var exists = Array.prototype.some.call(brandSelect.options, function (option) {
            return option.value === brand;
          });
          if (!exists) {
            var option = document.createElement('option');
            option.value = brand;
            option.textContent = brand;
            brandSelect.appendChild(option);
          }
        });
      }

      function updateYears(selectedYear) {
        var isCustomModel = isNewsletterForm && modelSelect.value === '__custom__';
        if (customModelWrap) customModelWrap.hidden = !isCustomModel;
        if (customModelInput) customModelInput.required = isCustomModel;
        if (isNewsletterForm) yearSelect.required = true;
        var brandModels = vehicleOptions[currentBrand()] || {};
        var years = isCustomModel ? [] : (brandModels[modelSelect.value] || []).slice().sort(function (a, b) {
          return Number(b) - Number(a);
        });
        replaceOptions(yearSelect, modelSelect.value ? (isNewsletterForm ? 'Select year' : 'All model years') : 'Select model first', years, selectedYear || '');
        if (isNewsletterForm && modelSelect.value) {
          var customYearOption = document.createElement('option');
          customYearOption.value = '__custom__';
          customYearOption.textContent = 'Other';
          customYearOption.selected = selectedYear === '__custom__';
          yearSelect.appendChild(customYearOption);
          yearSelect.disabled = false;
        }
        var isCustomYear = isNewsletterForm && yearSelect.value === '__custom__';
        if (customYearWrap) customYearWrap.hidden = !isCustomYear;
        if (customYearInput) customYearInput.required = isCustomYear;
        updateApplyState();
      }

      function updateModels(selectedModel, selectedYear) {
        var brandModels = vehicleOptions[currentBrand()] || {};
        var models = Object.keys(brandModels).sort(naturalCompare);
        replaceOptions(modelSelect, currentBrand() ? (isNewsletterForm ? 'Select model' : 'All vehicle models') : 'Select brand first', models, selectedModel || '');
        if (isNewsletterForm && currentBrand()) {
          var customOption = document.createElement('option');
          customOption.value = '__custom__';
          customOption.textContent = 'Other';
          customOption.selected = selectedModel === '__custom__';
          modelSelect.appendChild(customOption);
          modelSelect.disabled = false;
        }
        updateYears(selectedYear);
      }

      var initialModel = modelSelect.value;
      var initialYear = yearSelect.value;
      if (brandSelect) {
        brandSelect.addEventListener('change', function () {
          var isCustomBrand = isNewsletterForm && currentBrand() === '__custom__';
          if (customBrandWrap) customBrandWrap.hidden = !isCustomBrand;
          if (customBrandInput) customBrandInput.required = isCustomBrand;
          updateModels('', '');
          updateApplyState();
        });
      }
      modelSelect.addEventListener('change', function () {
        updateYears('');
        updateApplyState();
      });
      yearSelect.addEventListener('change', function () {
        var isCustomYear = isNewsletterForm && yearSelect.value === '__custom__';
        if (customYearWrap) customYearWrap.hidden = !isCustomYear;
        if (customYearInput) customYearInput.required = isCustomYear;
        updateApplyState();
      });
      if (customBrandInput) customBrandInput.addEventListener('input', updateApplyState);
      if (customModelInput) customModelInput.addEventListener('input', updateApplyState);
      if (customYearInput) customYearInput.addEventListener('input', updateApplyState);
      if (newsletterEmail) newsletterEmail.addEventListener('input', updateApplyState);
      if (isNewsletterForm) {
        if (newsletterStatus) {
          if (newsletterNote) newsletterNote.hidden = true;
          if (window.location.hash === '#nt-footer-newsletter-form') {
            window.setTimeout(function () {
              form.scrollIntoView({ behavior: 'smooth', block: 'center' });
              newsletterStatus.focus({ preventScroll: true });
            }, 0);
          }
        }
        form.addEventListener('submit', function (event) {
          if (newsletterSubmit && newsletterSubmit.disabled) {
            event.preventDefault();
            return;
          }
          if (!form.checkValidity()) return;
          if (newsletterSubmit) {
            newsletterSubmit.disabled = true;
            newsletterSubmit.setAttribute('aria-busy', 'true');
            newsletterSubmit.textContent = 'SUBMITTING...';
          }
          if (newsletterNote) {
            newsletterNote.hidden = false;
            newsletterNote.classList.add('is-submitting');
            newsletterNote.textContent = 'Submitting your subscription...';
          }
        });
      }
      if (form.hasAttribute('data-nt-collection-filter')) {
        form.addEventListener('submit', function (event) {
          if (!(currentBrand() || modelSelect.value || yearSelect.value)) event.preventDefault();
        });
      }
      updateModels(initialModel, initialYear);
      if (customBrandWrap) customBrandWrap.hidden = !(isNewsletterForm && currentBrand() === '__custom__');
      updateApplyState();
    });
  }

  function initNewsletterVehicleTags() {
    var form = document.getElementById('nt-footer-newsletter-form');
    if (!form || form.dataset.newsletterVehicleReady) return;
    form.dataset.newsletterVehicleReady = 'true';
    var tagsInput = form.querySelector('[data-nt-newsletter-tags]');
    var brandSelect = form.querySelector('[data-nt-vehicle-brand]');
    var modelSelect = form.querySelector('[data-nt-vehicle-model]');
    var yearSelect = form.querySelector('[data-nt-model-year]');
    var customBrandInput = form.querySelector('[data-nt-custom-brand]');
    var customModelInput = form.querySelector('[data-nt-custom-model]');
    var customYearInput = form.querySelector('[data-nt-custom-year]');
    if (!tagsInput || !brandSelect || !modelSelect || !yearSelect) return;
    var baseTags = tagsInput.value || 'newsletter';

    function cleanTagValue(value) {
      return String(value || '').replace(/,/g, ' ').replace(/\s+/g, ' ').trim();
    }

    function updateTags() {
      var tags = baseTags.split(',').map(cleanTagValue).filter(Boolean);
      var isCustomBrand = brandSelect.value === '__custom__';
      var isCustomModel = modelSelect.value === '__custom__';
      var isCustomYear = yearSelect.value === '__custom__';
      var brand = cleanTagValue(isCustomBrand && customBrandInput ? customBrandInput.value : brandSelect.value);
      var model = cleanTagValue(isCustomModel && customModelInput ? customModelInput.value : modelSelect.value);
      var year = cleanTagValue(isCustomYear && customYearInput ? customYearInput.value : yearSelect.value);
      if (brand) tags.push('newsletter-brand:' + brand);
      if (model) tags.push('newsletter-model:' + model);
      if (year) tags.push('newsletter-year:' + year);
      if (isCustomBrand) tags.push('newsletter-custom-brand');
      if (isCustomModel) tags.push('newsletter-custom-model');
      if (isCustomYear) tags.push('newsletter-custom-year');
      if (brand && model) tags.push('newsletter-bike:' + [brand, model, year].filter(Boolean).join(' '));
      tagsInput.value = tags.filter(function (tag, index, allTags) {
        return allTags.indexOf(tag) === index;
      }).join(', ');
    }

    [brandSelect, modelSelect, yearSelect].forEach(function (field) {
      field.addEventListener('change', updateTags);
    });
    if (customBrandInput) customBrandInput.addEventListener('input', updateTags);
    if (customModelInput) customModelInput.addEventListener('input', updateTags);
    if (customYearInput) customYearInput.addEventListener('input', updateTags);
    form.addEventListener('submit', updateTags);
    updateTags();
  }

  function initVehicleFallback() {
    var forms = document.querySelectorAll('[data-nt-vehicle-fallback]');
    forms.forEach(function (form) {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
    });
  }

  function initCounters() {
    var counters = document.querySelectorAll('[data-nt-count]');
    if (!counters.length) return;
    function run(counter) {
      if (counter.dataset.done) return;
      counter.dataset.done = 'true';
      var target = Number(counter.dataset.ntCount);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { counter.textContent = target; return; }
      var start = performance.now();
      function tick(now) {
        var progress = Math.min((now - start) / 1100, 1);
        counter.textContent = Math.round(target * (1 - Math.pow(1 - progress, 3)));
        if (progress < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    if (!('IntersectionObserver' in window)) { counters.forEach(run); return; }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) { run(entry.target); observer.unobserve(entry.target); } });
    }, { threshold: 0.35 });
    counters.forEach(function (counter) { observer.observe(counter); });
  }

  function createLatestReviewCard(review) {
    var media = Array.isArray(review.media) ? review.media.filter(function (item) { return item && item.url; }) : [];
    if (!review.id || !media.length) return null;

    var reviewId = 'submitted-' + String(review.id);
    var card = document.createElement('article');
    card.className = 'nt-review-card';
    card.dataset.ntReviewCard = '';
    card.dataset.ntReviewCustomer = review.customer || '';
    card.dataset.ntReviewPublishedAt = review.publishedAt || '';
    card.dataset.ntReviewHref = '/pages/reviews?review=' + encodeURIComponent(reviewId) + '#review-' + encodeURIComponent(reviewId);
    card.setAttribute('role', 'link');
    card.setAttribute('tabindex', '0');
    card.setAttribute('aria-label', 'View this customer review');

    var mediaWrap = document.createElement('div');
    mediaWrap.className = 'nt-review-media';
    media.forEach(function (item, index) {
      var isVideo = String(item.type || '').indexOf('video/') === 0;
      var slide = document.createElement(isVideo ? 'video' : 'img');
      slide.className = 'nt-review-slide' + (index === 0 ? ' is-active' : '');
      slide.dataset.ntReviewSlide = '';
      slide.hidden = index !== 0;
      if (isVideo) {
        slide.controls = true;
        slide.preload = 'metadata';
        slide.src = item.url;
      } else {
        slide.alt = (review.product || 'NT FAIRING') + ' owner photo ' + (index + 1);
        slide.loading = 'lazy';
        slide.decoding = 'async';
        if (index === 0) {
          var updateOrientation = function (event) {
            var image = event.currentTarget;
            card.classList.toggle('nt-review-card--portrait', image.naturalHeight > image.naturalWidth * 1.1);
          };
          slide.addEventListener('load', updateOrientation, { once: true });
        }
        slide.src = item.url;
        if (index === 0 && slide.complete) {
          card.classList.toggle('nt-review-card--portrait', slide.naturalHeight > slide.naturalWidth * 1.1);
        }
      }
      mediaWrap.appendChild(slide);
    });

    if (media.length > 1) {
      var previous = document.createElement('button');
      previous.className = 'nt-review-arrow nt-review-arrow--prev';
      previous.type = 'button';
      previous.setAttribute('aria-label', 'Previous customer photo');
      previous.dataset.ntReviewPrev = '';
      previous.textContent = '\u2039';

      var next = document.createElement('button');
      next.className = 'nt-review-arrow nt-review-arrow--next';
      next.type = 'button';
      next.setAttribute('aria-label', 'Next customer photo');
      next.dataset.ntReviewNext = '';
      next.textContent = '\u203a';

      var dots = document.createElement('div');
      dots.className = 'nt-review-dots';
      dots.setAttribute('aria-label', 'Customer photo pages');
      media.forEach(function (_item, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = index === 0 ? 'is-active' : '';
        dot.dataset.ntReviewDot = String(index);
        dot.setAttribute('aria-label', 'Show customer media ' + (index + 1));
        dots.appendChild(dot);
      });

      var count = document.createElement('span');
      count.className = 'nt-review-count';
      var current = document.createElement('b');
      current.dataset.ntReviewCurrent = '';
      current.textContent = '1';
      count.appendChild(current);
      count.appendChild(document.createTextNode('/' + media.length));
      mediaWrap.append(previous, next, dots, count);
    }
    card.appendChild(mediaWrap);

    var copy = document.createElement('div');
    copy.className = 'nt-review-copy';
    var stars = document.createElement('div');
    stars.className = 'nt-review-stars';
    var rating = Math.max(1, Math.min(5, Number(review.rating || 5)));
    stars.setAttribute('aria-label', rating + ' out of 5 stars');
    for (var index = 1; index <= 5; index += 1) {
      var star = document.createElement('span');
      if (index > rating) star.className = 'is-empty';
      star.textContent = '\u2605';
      stars.appendChild(star);
    }
    var score = document.createElement('em');
    score.textContent = rating.toFixed(1);
    stars.appendChild(score);

    var title = document.createElement('h3');
    title.textContent = review.title || 'Owner review';
    var quote = document.createElement('blockquote');
    quote.textContent = review.review || '';
    var footer = document.createElement('footer');
    var customer = document.createElement('span');
    customer.textContent = review.customer || 'Verified owner';
    var verified = document.createElement('b');
    verified.textContent = 'VERIFIED PURCHASE';
    var model = document.createElement('small');
    model.textContent = review.product || 'NT FAIRING OWNER BUILD';
    footer.append(customer, verified, model);
    copy.append(stars, title, quote, footer);
    card.appendChild(copy);
    return card;
  }

  function initLatestReviews() {
    function requestLatestReviews(feed, remainingAttempts) {
      var requestUrl = new URL(feed, window.location.origin);
      requestUrl.searchParams.set('_nt_latest', String(Date.now()));
      return fetch(requestUrl.toString(), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Latest reviews unavailable');
        return response.json();
      }).catch(function (error) {
        if (remainingAttempts <= 1) throw error;
        return new Promise(function (resolve) {
          window.setTimeout(resolve, 900);
        }).then(function () {
          return requestLatestReviews(feed, remainingAttempts - 1);
        });
      });
    }

    document.querySelectorAll('[data-nt-latest-reviews]').forEach(function (grid) {
      if (grid.dataset.latestReviewsReady) return;
      grid.dataset.latestReviewsReady = 'true';
      var feed = grid.dataset.ntReviewFeed;
      var isMobile = window.matchMedia('(max-width: 820px)').matches;
      var requestedLimit = isMobile && grid.dataset.ntReviewLimitMobile
        ? grid.dataset.ntReviewLimitMobile
        : grid.dataset.ntReviewLimit;
      var limit = Math.max(1, Number(requestedLimit || 5));
      if (!feed) return;
      grid.classList.add('is-loading');
      grid.setAttribute('aria-busy', 'true');

      requestLatestReviews(feed, 2)
        .then(function (payload) {
          var reviews = Array.isArray(payload.reviews) ? payload.reviews.slice() : [];
          reviews.sort(function (a, b) {
            return new Date(b.publishedAt || 0).getTime() - new Date(a.publishedAt || 0).getTime();
          });
          var seenCustomers = Object.create(null);
          var seenContent = Object.create(null);
          reviews = reviews.filter(function (review) {
            var customerKey = String(review.customer || '').trim().toLowerCase();
            var contentKey = [review.title, review.review].map(function (value) {
              return String(value || '').trim().toLowerCase();
            }).join('|');
            if (customerKey && seenCustomers[customerKey]) return false;
            if (contentKey !== '|' && seenContent[contentKey]) return false;
            if (customerKey) seenCustomers[customerKey] = true;
            if (contentKey !== '|') seenContent[contentKey] = true;
            return true;
          });
          var cards = reviews.map(createLatestReviewCard).filter(Boolean).slice(0, limit);
          if (!cards.length) return;
          grid.replaceChildren.apply(grid, cards);
          grid.classList.add('is-live');
          grid.dataset.ntReviewUpdatedAt = new Date().toISOString();
          initReviewCarousels();
        })
        .catch(function () {
          grid.classList.add('is-fallback');
          // The curated Liquid cards remain visible if the live feed is unavailable.
        })
        .then(function () {
          grid.classList.remove('is-loading');
          grid.removeAttribute('aria-busy');
        });
    });
  }

  function initReviewCarousels() {
    document.querySelectorAll('[data-nt-review-card]').forEach(function (card) {
      if (card.dataset.reviewReady) return;
      card.dataset.reviewReady = 'true';
      var slides = Array.prototype.slice.call(card.querySelectorAll('[data-nt-review-slide]'));
      var dots = Array.prototype.slice.call(card.querySelectorAll('[data-nt-review-dot]'));
      var current = card.querySelector('[data-nt-review-current]');
      var index = 0;
      var startX = 0;
      var didSwipe = false;

      function isInteractiveTarget(target) {
        return Boolean(target.closest('button, a, video, input, select, textarea, [controls]'));
      }

      function openAllReviews(event) {
        if (!card.dataset.ntReviewHref || isInteractiveTarget(event.target)) return;
        if (didSwipe) { didSwipe = false; return; }
        window.location.assign(card.dataset.ntReviewHref);
      }

      card.addEventListener('click', openAllReviews);
      card.addEventListener('keydown', function (event) {
        if ((event.key !== 'Enter' && event.key !== ' ') || isInteractiveTarget(event.target)) return;
        event.preventDefault();
        window.location.assign(card.dataset.ntReviewHref);
      });

      if (slides.length < 2) return;

      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === index;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (current) current.textContent = index + 1;
      }

      card.querySelector('[data-nt-review-prev]').addEventListener('click', function () { show(index - 1); });
      card.querySelector('[data-nt-review-next]').addEventListener('click', function () { show(index + 1); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { show(Number(dot.dataset.ntReviewDot)); });
      });
      card.querySelector('.nt-review-media').addEventListener('touchstart', function (event) {
        startX = event.touches[0].clientX;
        didSwipe = false;
      }, { passive: true });
      card.querySelector('.nt-review-media').addEventListener('touchend', function (event) {
        var distance = event.changedTouches[0].clientX - startX;
        if (Math.abs(distance) > 45) {
          didSwipe = true;
          show(index + (distance < 0 ? 1 : -1));
        }
      }, { passive: true });
      show(0);
    });
  }

  function init() {
    initHeader();
    initHero();
    initVehicleSelectors();
    initNewsletterVehicleTags();
    initFinder();
    initVehicleFallback();
    initCounters();
    initReviewCarousels();
    hideLegacyCurrencyControl();
    [250, 500, 1000, 2000, 4000, 7000].forEach(function (delay) { window.setTimeout(hideLegacyCurrencyControl, delay); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();


/* Storefront price display: symbol + amount only — 2026-09-18 */
(function () {
  var queued = false;

  function stripVisibleUsdCodes() {
    queued = false;
    document.querySelectorAll('.conversion-bear-money').forEach(function (node) {
      var current = node.textContent || '';
      var normalized = current.replace(/\s+USD(?=\s|$)/g, '');
      if (normalized !== current) node.textContent = normalized;
    });
  }

  function scheduleStrip() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(stripVisibleUsdCodes);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleStrip, { once: true });
  } else {
    scheduleStrip();
  }

  new MutationObserver(scheduleStrip).observe(document.documentElement, {
    childList: true,
    characterData: true,
    subtree: true
  });
})();
